import styled, { css } from 'styled-components'
import breakpoint from 'tools/styled-components-breakpoint'
import Div from 'components/Div'
import { gutterSize, marginSizes, responsiveSection } from 'theme/default'
import { pixelise } from 'tools/style'

const ResponsiveSection = styled(Div).attrs(() => ({
  marginBottom: marginSizes.medium,
  marginTop: marginSizes.medium
}))`
  width: 100%;
  display: block;
`

export const responsiveSectionStyle = css`
  max-width: calc(100vw - ${pixelise(gutterSize.mobile)});
  padding-right: ${pixelise(gutterSize.tablet / 2)};
  padding-left: ${pixelise(gutterSize.tablet / 2)};
  ${breakpoint('tablet')`
    padding-right: ${pixelise(gutterSize.tablet / 2)};
    padding-left: ${pixelise(gutterSize.tablet / 2)};
  `}
  ${breakpoint('desktop')`
    padding-right: ${pixelise(gutterSize.desktop / 2)};
    padding-left: ${pixelise(gutterSize.desktop / 2)};
    max-width: ${pixelise(responsiveSection.width)};
  `}

  @media only screen and (orientation: landscape) {
    .iPhoneX & {
      padding-left: env(safe-area-inset-left);
      padding-right: env(safe-area-inset-right);
    }
  }

  margin: 0 auto;
`

ResponsiveSection.Container = styled(Div)`
  ${responsiveSectionStyle}
`

export default ResponsiveSection
